import type { InputAdornmentProps } from '@mui/material';
import MuIInputAdornment from '@mui/material/InputAdornment';
import { forwardRef } from 'react';

const InputAdornment = forwardRef<HTMLDivElement, InputAdornmentProps>(
  (props, ref) => {
    return <MuIInputAdornment ref={ref} {...props} />;
  },
);
export default InputAdornment;
